import initialState from '../initial-state';
import * as types from '../actions/action-types';

export function albumsReducer(state = initialState.albums, action) {
	switch (action.type) {
		case types.APPEND_ALBUMS:
			return [...state, ...action.albums];
		case types.GET_ALBUMS:
			return action.albums;
		case types.SAVE_ALBUM:
			if (state.findIndex(album => album.id === action.album.id) >= 0) {
				return state.map(album => {
					if (album.id === action.album.id) {
						return action.album
					};
					return album;
				});
			} else {
				return [...[action.album], ...state]
			}
		case types.SET_ALBUMS:
			return action.albums;
		default:
			return state;
	}
}
